/* prettier-ignore */

const data = {
  common: {
    title: "Гахайн Сан",
    description: "Гахайн Сан Шийдэл",
    buttons: {
      search: "Хайх",
      login: "Нэвтрэх",
      register: "Бүртгүүлэх",
      approve: "Зөвшөөрөх",
      reject: "Татгалзах",
      refresh: "Шинэчлэх",
      viewDetails: "Дэлгэрэнгүй",
      back: "Буцах",
      cancel: "Цуцлах",
      confirm: "Баталгаажуулах",
      save: "Хадгалах",
      saving: "Хадгалж байна...",
      delete: "Устгах",
      deleting: "Устгаж байна...",
      hide: "Нуух",
      show: "Үзэх",
      close: "Хаасах",
    },
    placeholders: {
      search: "Хайх...",
    },
    messages: {
      success: "Амжилттай",
      updateSuccess: "Хэрэглэгчийн мэдээлэл шинэчлэгдсэн",
      loginSuccess: "Амжилттай нэвтэрлээ",
      logoutSuccess: "Амжилттай гарлаа",
      registerSuccess: "Бүртгэл амжилттай",
      criticalError: "Ноцтой алдаа гарлаа",
      forbidden: "Хориглосон хүсэлт",
      notAuthorized: "Эрх байхгүй",
      noData: "Мэдээлэл байхгүй",
      tooManyRequests: "Дахин оролдоно уу. Та ижил хүсэлтийг хэт хурдан давтан илгээж байна.",
      blocked: "Хэрэглэгч блоклогдсон",
      pending: "Хэрэглэгч хүлээгдэж байна",
      ipBlocked: "IP хаяг блоклогдсон",
      serverError: "Серверийн алдаа гарлаа",
      invalidInput: "Буруу оролт",
      invalidCredentials: "Хэрэглэгчийн нэр эсвэл нууц үг буруу байна",
      invalidReferrer: "Зөвлөгч байхгүй байна",
      referrerRequired: "Зөвлөгч шаардлагатай",
      ipBlockedFailed: "IP хаягийг блоклох боломжгүй",
      notAllowedPartner: "Зөвшөөрөгдөөгүй түнш",
      invalidPassword: "Нууц үг баталгаажуулах боломжгүй",
      databaseError: "Өгөгдлийн сангийн алдаа гарлаа",
      usernameInUse: "Хэрэглэгчийн нэр ашиглагдаж байна",
      createUserError: "Хэрэглэгч үүсгэх боломжгүй",
      failedFetch: "Өгөгдөл татаж чадсангүй",
      failedFetchUser: "Хэрэглэгчийн мэдээлэл татаж чадсангүй",
      failedFetchPendingUsers: "Хүлээгдэж буй хэрэглэгчдийн мэдээлэл татаж чадсангүй",
      failedFetchOnlineUsers: "Онлайн хэрэглэгчдийн мэдээлэл татаж чадсангүй",
      failedFetchUserTree: "Хэрэглэгчийн мод татаж чадсангүй",
      failedFetchUsers: "Хэрэглэгчдийн мэдээлэл татаж чадсангүй",
      failedFetchUserUpline: "Дээд шатны хэрэглэгчийн мэдээлэл татаж чадсангүй",
      failedFetchUserDownline: "Доод шатны хэрэглэгчийн мэдээлэл татаж чадсангүй",
      failedUpdate: "Өгөгдөл шинэчлэх боломжгүй",
      failedUpdateUser: "Хэрэглэгчийн мэдээлэл шинэчлэх боломжгүй",
      failedSave: "Өгөгдөл хадгалах боломжгүй",
      vendorError: "Нийлүүлэгчийн алдаа гарлаа",
      confirmDelete: "Та устгахдаа итгэлтэй байна уу?",
      deleteSuccess: "Хэрэглэгч устгагдлаа",
      tokenRefreshed: "Токен шинэчлэгдлээ",
      tokenRefreshFailed: "Токен шинэчлэх боломжгүй",
      invalidIpAddress: "Буруу IP хаяг",
      invalidChipTransactionReason: "Чипийн гүйлгээний шалтгаан буруу байна",
      captchaExpired: "Captcha хугацаа дууссан",
      captchaInvalid: "Captcha буруу байна",
      insufficientChip: "Чип хүрэлцэхгүй байна",
      insufficientPoint: "Оноо хүрэлцэхгүй байна",
      failedCollectChips: "Чип цуглуулах боломжгүй",
      failedGiveChips: "Чип өгөх боломжгүй",
      failedPointsToChips: "Оноог чип болгох боломжгүй",
      notFoundHeadquarter: "Төв байгууллага олдсонгүй",
      notFoundUser: "Хэрэглэгч олдсонгүй",
      failedFetchAdmin: "Админы мэдээлэл татаж чадсангүй",
      failedFetchHeadquarter: "Төв байгууллагын мэдээлэл татаж чадсангүй",
      adminNotAllowed: "Админ зөвшөөрөгдөөгүй",
      partnerNotAllowed: "Түнш зөвшөөрөгдөөгүй",
      userNotAllowed: "Хэрэглэгч зөвшөөрөгдөөгүй",
      failedFetchTotalInquiries: "Нийт асуулгын мэдээлэл татаж чадсангүй",
      failedFetchInquiries: "Асуулгын мэдээлэл татаж чадсангүй",
      failedCreateInquiry: "Асуулга үүсгэх боломжгүй",
      failedUpdateInquiry: "Асуулга шинэчлэх боломжгүй",
      failedFetchInquiry: "Асуулгын мэдээлэл татаж чадсангүй",
      failedFetchTotalNotices: "Нийт мэдэгдлийн мэдээлэл татаж чадсангүй",
      failedFetchNotices: "Мэдэгдлийн мэдээлэл татаж чадсангүй",
      failedCreateNotice: "Мэдэгдэл үүсгэх боломжгүй",
      failedUpdateNotice: "Мэдэгдэл шинэчлэх боломжгүй",
      failedIncrementNoticeViewCount: "Мэдэгдлийн үзэлтийн тоог нэмэгдүүлэх боломжгүй",
      failedFetchNotice: "Мэдэгдлийн мэдээлэл татаж чадсангүй",
      failedFetchBankingHistory: "Банкны түүх татаж чадсангүй",
      failedFetchTotalBankingHistory: "Нийт банкны түүх татаж чадсангүй",
      failedFetchDownlineBankingHistory: "Доод шатны банкны түүх татаж чадсангүй",
      failedFetchDownlineTotalBankingHistory: "Доод шатны нийт банкны түүх татаж чадсангүй",
      failedAddBankingHistory: "Банкны түүх нэмэх боломжгүй",
      failedUpdateBankingHistoryStatus: "Банкны түүхийн төлөв шинэчлэх боломжгүй",
      failedFetchChipTransactionHistory: "Чипийн гүйлгээний түүх татаж чадсангүй",
      failedFetchTotalChipTransactionHistory: "Нийт чипийн гүйлгээний түүх татаж чадсангүй",
      failedFetchDownlineChipTransactionHistory: "Доод шатны чипийн гүйлгээний түүх татаж чадсангүй",
      failedFetchDownlineTotalChipTransactionHistory: "Доод шатны нийт чипийн гүйлгээний түүх татаж чадсангүй",
      failedAddChipTransactionHistory: "Чипийн гүйлгээний түүх нэмэх боломжгүй",
      failedFetchGameBetHistoryByCallbackId: "Тоглоомын бооцооны түүхийг callback ID-гаар татаж чадсангүй",
      failedFetchGameBetHistory: "Тоглоомын бооцооны түүх татаж чадсангүй",
      failedFetchTotalGameBetHistory: "Нийт тоглоомын бооцооны түүх татаж чадсангүй",
      failedFetchDownlineGameBetHistory: "Доод шатны тоглоомын бооцооны түүх татаж чадсангүй",
      failedFetchDownlineTotalGameBetHistory: "Доод шатны нийт тоглоомын бооцооны түүх татаж чадсангүй",
      failedAddGameBetHistory: "Тоглоомын бооцооны түүх нэмэх боломжгүй",
      failedFetchChipChangeHistory: "Чипийн өөрчлөлтийн түүх татаж чадсангүй",
      failedFetchTotalChipChangeHistory: "Нийт чипийн өөрчлөлтийн түүх татаж чадсангүй",
      failedAddChipChangeHistory: "Чипийн өөрчлөлтийн түүх нэмэх боломжгүй",
      failedFetchGameCallbackHistory: "Тоглоомын callback түүх татаж чадсангүй",
      failedFetchTotalGameCallbackHistory: "Нийт тоглоомын callback түүх татаж чадсангүй",
      failedAddGameCallbackHistory: "Тоглоомын callback түүх нэмэх боломжгүй",
      failedUpdateGameCallbackHistory: "Тоглоомын callback түүх шинэчлэх боломжгүй",
      failedDeleteGameCallbackHistory: "Тоглоомын callback түүх устгах боломжгүй",
      failedFetchGamePlayHistory: "Тоглоомын түүх татаж чадсангүй",
      failedFetchTotalGamePlayHistory: "Нийт тоглоомын түүх татаж чадсангүй",
      failedAddGamePlayHistory: "Тоглоомын түүх нэмэх боломжгүй",
      failedFetchLoginHistory: "Нэвтрэх түүх татаж чадсангүй",
      failedFetchTotalLoginHistory: "Нийт нэвтрэх түүх татаж чадсангүй",
      failedAddLoginHistory: "Нэвтрэх түүх нэмэх боломжгүй",
      failedFetchPointChangeHistory: "Оноо өөрчлөлтийн түүх татаж чадсангүй",
      failedFetchTotalPointChangeHistory: "Нийт оноо өөрчлөлтийн түүх татаж чадсангүй",
      failedAddPointChangeHistory: "Оноо өөрчлөлтийн түүх нэмэх боломжгүй",
      failedFetchSettings: "Тохиргооны мэдээлэл татаж чадсангүй",
      failedFetchSettingByKey: "Тохиргооны мэдээллийг түлхүүрээр татаж чадсангүй",
      failedCreateSetting: "Тохиргоо үүсгэх боломжгүй",
      noFieldsToUpdateSetting: "Шинэчлэх талбар байхгүй байна",
      settingNotFound: "Тохиргоо олдсонгүй",
      failedUpdateSetting: "Тохиргоо шинэчлэх боломжгүй",
      failedDeleteSetting: "Тохиргоо устгах боломжгүй",
      failedUpdateMultipleSettings: "Олон тохиргоо шинэчлэх боломжгүй",
      failedFetchUserDownlineTotalFinance: "Доод шатны нийт санхүүгийн мэдээлэл татаж чадсангүй",
      failedFetchUserDownlineSettlement: "Доод шатны тооцооны мэдээлэл татаж чадсангүй",
      failedFetchMyTotalAddedChips: "Нийт нэмсэн чипийн мэдээлэл татаж чадсангүй",
      failedFetchMyTotalSubtractedChips: "Нийт хасагдсан чипийн мэдээлэл татаж чадсангүй",
      failedFetchMyMoneyChanges: "Мөнгөний өөрчлөлтийн мэдээлэл татаж чадсангүй",
      failedFetchTodaysNewUsers: "Өнөөдрийн шинэ хэрэглэгчдийн тоо татаж чадсангүй",
      failedFetchTodayStats: "Өнөөдрийн статистик татаж чадсангүй",
      failedFetchTotalPendingUsers: "Нийт хүлээгдэж буй хэрэглэгчдийн тоо татаж чадсангүй",
      failedFetchTotalOnlineUsers: "Нийт онлайн хэрэглэгчдийн тоо татаж чадсангүй",
      failedFetchTotalPendingInquiries: "Нийт хүлээгдэж буй асуулгын тоо татаж чадсангүй",
      failedFetchTotalDepositAndWithdraw: "Нийт орлого, зарлагын мэдээлэл татаж чадсангүй",
      failedFetchMonitoringStats: "Хяналтын статистик татаж чадсангүй",
      failedUpdateUserFinance: "Хэрэглэгчийн санхүүгийн мэдээлэл шинэчлэх боломжгүй",
      failedAddUserChip: "Хэрэглэгчийн чип нэмэх боломжгүй",
      failedAddUserPoint: "Хэрэглэгчийн оноо нэмэх боломжгүй",
      failedSubtractUserChip: "Хэрэглэгчийн чип хасах боломжгүй",
      failedCollectSubUserChips: "Доод шатны хэрэглэгчийн чип цуглуулах боломжгүй",
      failedGiveChipsToSubUser: "Доод шатны хэрэглэгчид чип өгөх боломжгүй",
      failedUpdateUserStatus: "Хэрэглэгчийн төлөв шинэчлэх боломжгүй",
      failedUpdateUserRole: "Хэрэглэгчийн үүрэг шинэчлэх боломжгүй",
      failedUpdateUserOnlineStatus: "Хэрэглэгчийн онлайн төлөв шинэчлэх боломжгүй",
      failedUpdateGameVendorForDownline: "Доод шатны тоглоомын нийлүүлэгч шинэчлэх боломжгүй",
      failedCreateUsers: "Олон хэрэглэгч үүсгэх боломжгүй",
      failedFetchUserById: "ID-гаар хэрэглэгч татаж чадсангүй",
      failedFetchUserByVendorId: "Нийлүүлэгчийн ID-гаар хэрэглэгч татаж чадсангүй",
      failedFetchUserFinance: "Хэрэглэгчийн санхүүгийн мэдээлэл татаж чадсангүй",
      failedFetchUserRowsByRole: "Үүргээр хэрэглэгчийн мөрүүдийг татаж чадсангүй",
      failedFetchAdminId: "Админы ID татаж чадсангүй",
      failedFetchHeadquarterId: "Төв байгууллагын ID татаж чадсангүй",
      failedFetchUsersByReferrer: "Зөвлөгчөөр хэрэглэгч татаж чадсангүй",
      failedFetchUsersWithoutReferrer: "Зөвлөгчгүй хэрэглэгч татаж чадсангүй",
      failedFetchPendingUsersTotal: "Нийт хүлээгдэж буй хэрэглэгчдийн тоо татаж чадсангүй",
      failedFetchOnlineUsersTotal: "Нийт онлайн хэрэглэгчдийн тоо татаж чадсангүй",
      failedFetchUserDetail: "Хэрэглэгчийн дэлгэрэнгүй мэдээлэл татаж чадсангүй",
      userNotFound: "Хэрэглэгч олдсонгүй",
      failedFetchVendorHistory: "Нийлүүлэгчийн түүх татаж чадсангүй",
      failedAddVendorHistory: "Нийлүүлэгчийн түүх нэмэх боломжгүй",
      failedUpdateVendorHistory: "Нийлүүлэгчийн түүх шинэчлэх боломжгүй",
      referrerNotFound: "Зөвлөгч олдсонгүй",
      failedToGetAdminId: "Админы ID авах боломжгүй",
      failedToGetHeadquarterId: "Төв байгууллагын ID авах боломжгүй",
      failedToGetUserDetail: "Хэрэглэгчийн дэлгэрэнгүй мэдээлэл авах боломжгүй",
      failedToGetUserFinance: "Хэрэглэгчийн санхүүгийн мэдээлэл авах боломжгүй",
      failedFetchUserByRole: "Үүргээр хэрэглэгч татаж чадсангүй",
      failedAddBetAmount: "Бооцооны дүн нэмэх боломжгүй",
      invalidReason: "Буруу шалтгаан",
      refreshTokenRequired: "Шинэчлэх токен шаардлагатай",
    },
    pagination: {
      previous: "Өмнөх",
      next: "Дараах",
      page: "Хуудас",
    },
    roles: {
      admin: "Админ",
      headquarter: "Төв",
      headquarter_branch: "Төв",
      branch: "Салбар",
      distributor: "Түгээгч",
      store: "Дэлгүүр",
      user: "Хэрэглэгч",
    },
    appBar: {
      search: {
        placeholder: "Хайх...",
      },
      userProfile: "Профайл",
      userSettings: "Тохиргоо",
      darkMode: "Харанхуй горим",
      lightMode: "Гэрэлтэй горим",
      logout: "Гарах",
    },
    loading: {
      loading: "Ачаалж байна...",
      error: "Алдаа гарлаа: ",
    },
    search: {
      placeholder: "Хайх үгээ оруулна уу",
      button: "Хайх",
      datePlaceholder: "Огноо сонгох",
    },
    userTree: {
      title: "Хэрэглэгч түүх",
    },
    status: {
      pending: "Хүлээгдэж байна",
      approved: "Зөвшөөрсөн",
      rejected: "Татгалзсан",
      canceled: "Цуцалсан",
    },
    gameVendorSelect: {
      officialLabel: "Оффициаль тоглоомын нийлүүлэгч",
      unofficialLabel: "Оффициаль биш тоглоомын нийлүүлэгч",
      officialPlaceholder: "Оффициаль тоглоомын нийлүүлэгч сонгох",
      unofficialPlaceholder: "Оффициаль биш тоглоомын нийлүүлэгч сонгох",
      save: "Хадгалах",
      none: "Хэрэглэгч",
    },
    dateRangeSelector: {
      startDatePlaceholder: "Эхлэх огноо",
      endDatePlaceholder: "Дуусах огноо",
      selectPlaceholder: "Огноо сонгох",
      periods: {
        day: "Өнөөдөр",
        week: "1 үе",
        twoWeeks: "2주일",
        month: "1 сар",
        threeMonths: "3 сар",
        sixMonths: "6 сар",
        year: "1 жил",
        custom: "Зөвшөөрсөн",
      },
    },
  },
  auth: {
    login: "Нэвтрэх",
    register: "Бүртгүүлэх",
    loginDescription: "Нэвтрэхийн тулд хэрэглэгчийн нэр, нууц үгээ оруулна уу",
    registerDescription: "Шинэ бүртгэл үүсгэх",
    email: "Имэйл",
    password: "Нууц үг",
    username: "Хэрэглэгчийн нэр",
    referrer: "Зөвлөгч",
    referrerPlaceholder: "Зөвлөгчийн хэрэглэгчийн нэрийг оруулна уу",
    confirmPassword: "Нууц үгээ баталгаажуулах",
    loginButton: "Нэвтрэх",
    registerButton: "Бүртгүүлэх",
    captcha: "Аюулгүйн асуулт",
    captchaPlaceholder: "Хариултаа оруулна уу",
    loginProcessing: "Нэвтэрч байна...",
    registerProcessing: "Боловсруулж байна...",
    hasAccount: "Бүртгэлтэй юу?",
    noAccount: "Бүртгэлгүй юу?",
    goToLogin: "Нэвтрэх хэсэг рүү очих",
    goToRegister: "Бүртгүүлэх хэсэг рүү очих",
    minLengthUsername: "Хэрэглэгчийн нэр хамгийн багадаа 3 тэмдэгт байх ёстой",
    minLengthPassword: "Нууц үг хамгийн багадаа 8 тэмдэгт байх ёстой",
    invalidCaptcha: "Аюулгүйн асуултын хариулт буруу байна",
    passwordMismatch: "Нууц үг таарахгүй байна",
    loginSuccess: "Амжилттай нэвтэрлээ",
    registerSuccess: "Бүртгэл амжилттай",
    refresh: "Шинэчлэх"
  },
  sidebar: {
    systemManagement: "Систем/Мэдэгдэл",
    partnerManagement: "Түншийн удирдлага",
    userManagement: "Хэрэглэгчийн удирдлага",
    bankingManagement: "Банкны удирдлага",
    bettingStatus: "Бооцооны төлөв & Тооцоо",
    apiDocs: "API Баримт бичиг",
    settings: "Тохиргоо",
  },
  statsOverview: {
    balance: "Үлдэгдэл",
    pendingApproval: "Зөвшөөрөл хүлээж байгаа",
    depositRequest: "Орлогын хүсэлт",
    withdrawRequest: "Зарлагын хүсэлт",
    inquiry: "1:1 Асуулга",
    currentUsers: "Одоогийн хэрэглэгчид",
    cases: "Тохиолдлууд",
    users: "Хэрэглэгчид",
    userBalance: "User Chip Balance",
    userPoint: "User Point Balance",
    partnerBalance: "Partner Chip Balance",
    partnerPoint: "Partner Point Balance",
  },
  dashboard: {
    title: "Хяналтын самбар",
    desc: "Админ хяналтын самбар",
    registeredUsers: "Бүртгүүлсэн хэрэглэгчид",
    activeUsers: "Идэвхтэй хэрэглэгчид",
    systemStatus: "Системийн төлөв",
    systemNormal: "Хэвийн",
    allSystemsOperational: "Бүх систем ажиллаж байна",
    topStats: {
      chip: {
        title: "Чипийн үлдэгдэл",
        vendorBalance: "Нийлүүлэгчийн чипийн үлдэгдэл",
      },
      point: {
        title: "Оноо",
        convertButton: "Чип рүү хөрвүүлэх",
      },
      user: {
        title: "Хэрэглэгч",
        listButton: "Харьяа хэрэглэгчдийн жагсаалт",
      },
    },
    moneyStatus: {
      userBalance: "Хэрэглэгчийн чипийн үлдэгдэл",
      userPoint: "Хэрэглэгчийн оноо",
      partnerBalance: "Түншийн чипийн үлдэгдэл",
      partnerPoint: "Түншийн оноо",
    },
    transactionSummary: {
      deposit: "Орлого",
      withdraw: "Зарлага",
      chipGive: "Өгсөн чип",
      chipCollect: "Цуглуулсан чип",
      newUsers: "Өнөөдрийн шинэ хэрэглэгчид",
      profit: "Өнөөдрийн бооцооны ашиг",
      profitDesc: "(Бооцоо - Хожил - Эргэлт)",
    },
    transactionDetails: {
      title: "Үлдэгдэл = Чип + Эргэлт, Орлого/Зарлага нь харьяа гишүүдийн орлого/зарлагын нийлбэр юм",
      search: "Хайх",
      prevBalance: "Өмнөх үлдэгдэл",
      deposit: "Орлого",
      withdraw: "Зарлага",
      currentBalance: "Одоогийн үлдэгдэл",
      bettingWinning: "Бооцоо / Хожил",
      rolling: "Эргэлт",
      userBalanceLabel: "Хэрэглэгчийн үлдэгдэл",
      partnerBalanceLabel: "Түншийн үлдэгдэл",
      depositLabel: "Орлого",
      chipGiveLabel: "Өгсөн чип",
      totalLabel: "Нийт",
      withdrawLabel: "Зарлага",
      chipCollectLabel: "Цуглуулсан чип",
      bettingLabel: "Бооцооны дүн",
      winningLabel: "Хожлын дүн",
      bettingResultLabel: "Бооцоо - Хожил",
      totalRollingLabel: "Нийт эргэлт",
      actualRollingLabel: "Бодит эргэлт",
    },
    transactionHistory: {
      title: "Гүйлгээний түүх",
      search: "Хайх",
      increase: {
        title: "Үлдэгдэл нэмэгдсэн",
        headDeposit: "Компанийн орлого",
        upperChipGive: "Дээд түвшний чип өгөх",
        lowerChipCollect: "Доод түвшний чип цуглуулах",
        rollingConvert: "Эргэлт хөрвүүлэх",
        total: "Нэмэгдсэн нийт дүн",
      },
      decrease: {
        title: "Үлдэгдэл буурсан",
        headWithdraw: "Компанийн зарлага",
        upperChipCollect: "Дээд түвшний чип цуглуулах",
        lowerChipGive: "Доод түвшний чип өгөх",
        total: "Буурсан нийт дүн",
      },
    },
    notice: {
      title: "Мэдэгдэл",
      columns: {
        id: "#",
        title: "Гарчиг",
        createdAt: "Үүсгэсэн огноо",
      },
    },
  },
  users: {
    list: {
      title: "Хэрэглэгчийн жагсаалт",
      desc: "Бүртгүүлсэн хэрэглэгчдийг удирдах",
      columns: {
        username: "Хэрэглэгчийн ID",
        details: "Дэлгэрэнгүй",
        banking: "Цэнэглэх/Солилцох",
        chip: "Чипийн үлдэгдэл",
        point: "Оноо",
        affiliation: "Харьяалал",
        depositWithdraw: "Орлого/Зарлага",
        slotStats: "(Слот)/Бооцоо/Хожил/Эргэлт",
        casinoStats: "(Казино)/Бооцоо/Хожил/Эргэлт",
        sportsStats: "(Спорт)/Бооцоо/Хожил/Эргэлт",
      },
      filters: {
        byUsername: "Хэрэглэгчийн ID-гаар",
        byChip: "Чипийн үлдэгдлээр",
        byLatest: "Сүүлийнх",
        byOldest: "Хуучин",
      },
    },
    pending: {
      title: "Хүлээгдэж буй хэрэглэгчид",
      desc: "Хүлээгдэж буй хэрэглэгчдийг удирдах",
      columns: {
        username: "Хэрэглэгчийн ID",
        details: "Дэлгэрэнгүй",
        status: "Төлөв",
        headquarter: "Төв",
        branch: "Салбар",
        distributor: "Түгээгч",
        store: "Дэлгүүр",
        createdAt: "Үүсгэсэн огноо",
        contact: "Холбоо барих",
        actions: "Үйлдлүүд",
      },
      approve: "Зөвшөөрөх",
      reject: "Татгалзах",
      pendingStatus: "Хүлээгдэж байна",
      viewDetails: "Дэлгэрэнгүй харах",
    },
    online: {
      title: "Онлайн хэрэглэгчид",
      desc: "Онлайн хэрэглэгчдийг удирдах",
      columns: {
        username: "Хэрэглэгчийн ID",
        details: "Дэлгэрэнгүй",
        accountHolder: "Данс эзэмшигч",
        affiliation: "Харьяалал",
        banking: "Цэнэглэх/Солилцох",
        chip: "Чипийн үлдэгдэл",
        depositWithdraw: "Нийт орлого/Зарлага",
        slotStats: "(Слот)/Бооцоо/Хожил/Эргэлт",
        casinoStats: "(Казино)/Бооцоо/Хожил/Эргэлт",
        sportsStats: "(Спорт)/Бооцоо/Хожил/Эргэлт",
        lastPlayedGame: "Сүүлийн тоглосон тоглоом",
      },
      noLastGame: "Бүртгэл байхгүй",
    },
    chip: {
      giveTitle: "Чип өгөх",
      collectTitle: "Чип цуглуулах",
      giftTitle: "Чип бэлэглэх",
      giveChip: "Чип өгөх",
      collectChip: "Чип цуглуулах",
      giftChip: "Чип бэлэглэх",
      description: "Дүн болон шалтгааныг оруулаад баталгаажуулах товчийг дарна уу.",
      amount: "Дүн",
      memo: "Тэмдэглэл",
      memoPlaceholder: "Тэмдэглэл оруулна уу",
      errors: {
        invalidAmount: "Зөв дүн оруулна уу",
        actionFailed: "Үйлдэл амжилтгүй боллоо",
      },
    },
    status: {
      active: "Идэвхтэй",
      pending: "Хүлээгдэж байна",
      rejected: "Татгалзсан",
      block: "Хаагдсан",
      online: "Онлайн",
      offline: "Оффлайн",
    },
    detail: {
      title: "Хэрэглэгчийн дэлгэрэнгүй",
      desc: "Хэрэглэгчийн дэлгэрэнгүй мэдээллийг удирдах",
      tabs: {
        userInfo: "Хэрэглэгчийн мэдээлэл",
        loginHistory: "Нэвтрэх түүх",
        messages: "Мессежүүд",
        chipChangeHistory: "Чипийн өөрчлөлтийн түүх",
        rechargeHistory: "Цэнэглэлтийн түүх",
        exchangeHistory: "Солилцооны түүх",
        chipReceivedHistory: "Хүлээн авсан чипийн түүх",
        chipSentHistory: "Илгээсэн чипийн түүх",
        gamePlayHistory: "Тоглоомын түүх",
        gameBetHistory: "Тоглоомын бооцооны түүх",
        restrictedGameBetting: "Хязгаарлагдсан тоглоомын бооцоо",
        pragmatic: "Прагматик",
        userLogs: "Хэрэглэгчийн бүртгэл",
      },
      userSummary: {
        role: "Үүрэг",
        username: "Хэрэглэгчийн нэр",
        chip: "Чип",
        point: "Оноо",
      },
      userInfo: {
        title: "Хэрэглэгчийн дэлгэрэнгүй",
        basicInfo: "Үндсэн мэдээлэл",
        moneyInfo: "Санхүүгийн мэдээлэл",
        gameInfo: "Тоглоомын мэдээлэл",
        bankInfo: "Банкны мэдээлэл",
        number: "Дугаар",
        password: "Нууц үг",
        username: "Хэрэглэгчийн нэр",
        contact: "Холбоо барих",
        status: "Төлөв",
        gameVendor: "Тоглоом нийлүүлэгч",
        gameVendorPlaceholder: "Тоглоом нийлүүлэгч сонгох",
        chip: "Чип",
        point: "Оноо",
        totalDeposit: "Нийт орлого",
        totalWithdraw: "Нийт зарлага",
        slotBet: "Слот бооцоо",
        slotWin: "Слот хожил",
        casinoBet: "Казино бооцоо",
        casinoWin: "Казино хожил",
        sportsBet: "Спорт бооцоо",
        sportsWin: "Спорт хожил",
        casinoBetLimit: "Лайв казино бооцооны хязгаар",
        casinoWinLimit: "Лайв казино хожлын хязгаар",
        bankName: "Банкны нэр",
        bankAccount: "Дансны дугаар",
        bankAccountHolder: "Данс эзэмшигч",
        memo: "Тэмдэглэл",
        memoPlaceholder: "Тэмдэглэл оруулна уу",
        createdAt: "Бүртгүүлсэн огноо",
        lastLogin: "Сүүлд нэвтэрсэн",
        blockRejectReason: "Хаах/Татгалзах шалтгаан",
        blockRejectReasonPlaceholder: "Хаах эсвэл татгалзах шалтгааныг оруулна уу",
      },
      loginHistory: {
        title: "Нэвтрэх түүх",
        columns: {
          ipAddr: "IP хаяг",
          isSuccess: "Амжилттай",
          createdAt: "Нэвтэрсэн цаг",
          actions: "Үйлдлүүд",
          blockIP: "IP хаяг блоклох",
        },
      },
      chipChangeHistory: {
        title: "Чипийн өөрчлөлтийн түүх",
        columns: {
          amountBefore: "Өмнө",
          amountAfter: "Дараа",
          amountDiff: "Өөрчлөлт",
          sender: "Илгээгч",
          receiver: "Хүлээн авагч",
          reason: "Шалтгаан",
          referenceValue: "Лавлах утга",
          rollingBefore: "Эргэлт (Өмнө)",
          rollingAfter: "Эргэлт (Дараа)",
          createdAt: "Өөрчлөлтийн цаг",
        },
      },
      rechargeHistory: {
        title: "Цэнэглэлтийн түүх",
        columns: {
          amountBefore: "Өмнө",
          amountAfter: "Дараа",
          requestAmount: "Хүсэлтийн дүн",
          bankInfo: "Банкны мэдээлэл",
          status: "Төлөв",
          requestedAt: "Хүсэлт гаргасан",
          processedAt: "Боловсруулсан",
          memo: "Тэмдэглэл",
        },
      },
      exchangeHistory: {
        title: "Солилцооны түүх",
        columns: {
          amountBefore: "Өмнө",
          amountAfter: "Дараа",
          requestAmount: "Хүсэлтийн дүн",
          bankInfo: "Банкны мэдээлэл",
          status: "Төлөв",
          requestedAt: "Хүсэлт гаргасан",
          processedAt: "Боловсруулсан",
          memo: "Тэмдэглэл",
        },
      },
      chipReceiveHistory: {
        title: "Хүлээн авсан чипийн түүх",
        columns: {
          receiverId: "Хүлээн авагчийн ID",
          receiverUsername: "Хүлээн авагчийн нэр",
          receiverRole: "Хүлээн авагчийн үүрэг",
          amount: "Чипийн дүн",
          reason: "Шалтгаан",
          memo: "Тэмдэглэл",
          createdAt: "Үүсгэсэн огноо",
        },
      },
      chipSendHistory: {
        title: "Илгээсэн чипийн түүх",
        columns: {
          senderId: "Илгээгчийн ID",
          senderUsername: "Илгээгчийн нэр",
          senderRole: "Илгээгчийн үүрэг",
          amount: "Чипийн дүн",
          reason: "Шалтгаан",
          memo: "Тэмдэглэл",
          createdAt: "Үүсгэсэн огноо",
        },
      },
      gamePlayHistory: {
        title: "Тоглоомын түүх",
        columns: {
          supplier: "Нийлүүлэгч",
          gameName: "Тоглоомын нэр",
          executionTime: "Гүйцэтгэх хугацаа",
        },
      },
      gameBetHistory: {
        title: "Тоглоомын бооцооны түүх",
        columns: {
          supplier: "Нийлүүлэгч",
          gameName: "Тоглоомын нэр",
          roundId: "Тойргийн ID",
          type: "Төрөл",
          betAmount: "Бооцооны дүн",
          winAmount: "Хожлын дүн",
          balance: "Үлдэгдэл",
          betTime: "Бооцооны цаг",
          details: "Дэлгэрэнгүй",
        },
      },
    },
    creation: {
      title: "Хэрэглэгч үүсгэх",
      desc: "Шинэ {0} үүсгэх",
      username: "Хэрэглэгчийн нэр",
      usernamePlaceholder: "Хэрэглэгчийн нэр оруулна уу",
      password: "Нууц үг",
      passwordPlaceholder: "Нууц үг оруулна уу",
      count: "Тоо",
      countPlaceholder: "Тоо оруулна уу",
      contact: "Холбоо барих",
      contactPlaceholder: "Холбоо барих мэдээлэл оруулна уу",
      bank: "Банк",
      bankSelect: "=== Сонгох ===",
      bankKookmin: "Күүкмин",
      bankShinhan: "Шинхан",
      bankWoori: "Үүри",
      bankNonghyup: "Нонхёп",
      bankHana: "Хана",
      accountNumber: "Дансны дугаар",
      accountNumberPlaceholder: "Дансны дугаар оруулна уу",
      accountHolder: "Данс эзэмшигч",
      accountHolderPlaceholder: "Данс эзэмшигчийн нэр оруулна уу",
      rollingRateSlot: "Эргэлтийн хувь (Слот)",
      losingRateSlot: "Алдагдлын хувь (Слот)",
      rollingRateCasino: "Эргэлтийн хувь (Казино)",
      losingRateCasino: "Алдагдлын хувь (Казино)",
      rollingRateSports: "Эргэлтийн хувь (Спорт)",
      losingRateSports: "Алдагдлын хувь (Спорт)",
      errors: {
        requiredFields: "Хэрэглэгчийн нэр болон нууц үгийг оруулна уу",
        invalidCount: "Тоо 0-ээс их байх ёстой",
      },
    }
  },
  partners: {
    common: {
      add: "Түнш нэмэх",
    },
    list: {
      all: {
        title: "Түншийн жагсаалт",
        desc: "Бүртгүүлсэн түншүүдийг удирдах",
      },
      head: {
        title: "Төвийн жагсаалт",
        desc: "Бүртгүүлсэн төвүүдийг удирдах",
      },
      headBranch: {
        title: "Төвийн жагсаалт",
        desc: "Бүртгүүлсэн төвүүдийг удирдах",
      },
      branch: {
        title: "Салбарын жагсаалт",
        desc: "Бүртгүүлсэн салбаруудыг удирдах",
      },
      distributor: {
        title: "Түгээгчийн жагсаалт",
        desc: "Бүртгүүлсэн түгээгчдийг удирдах",
      },
      store: {
        title: "Дэлгүүрийн жагсаалт",
        desc: "Бүртгүүлсэн дэлгүүрүүдийг удирдах",
      },
      search: {
        placeholder: "Түншийн хэрэглэгчийн нэрийг оруулна уу",
      },
      columns: {
        username: "Хэрэглэгчийн ID",
        details: "Дэлгэрэнгүй",
        role: "Үүрэг",
        banking: "Цэнэглэх/Солилцох",
        chip: "Чипийн үлдэгдэл",
        point: "Оноо",
        depositWithdraw: "Орлого/Зарлага",
        rollingPercentage: {
          slot: "Эргэлтийн % (Слот)",
          casino: "Эргэлтийн % (Казино)",
          sports: "Эргэлтийн % (Спорт)",
        },
        losingPercentage: {
          slot: "Алдагдлын % (Слот)",
          casino: "Алдагдлын % (Казино)",
          sports: "Алдагдлын % (Спорт)",
        },
        createdAt: "Үүсгэсэн огноо",
        hqTransactions: "Төв орлого/Зарлага",
        chipTransactions: "Өгсөн/Цуглуулсан чип",
        betting: {
          casino: "Бооцоо(Казино)",
          slot: "Бооцоо(Слот)",
          sports: "Бооцоо(Спорт)",
        },
        downlineManagement: "Доод түвшний удирдлага",
        createDownline: "Доод түвшин үүсгэх",
      },
      statsCard: {
        basicInfo: {
          title: "Үндсэн мэдээлэл",
          type: "Төрөл",
          username: "Хэрэглэгчийн нэр",
          chipAndPointBalance: "Чип / Оноо",
          contact: "Холбоо барих",
          bankName: "Банкны нэр",
          bankAccount: "Дансны дугаар",
          accountHolder: "Данс эзэмшигч",
        },
        rollingAndLosing: {
          title: "Эргэлт & Алдагдал",
          convertButton: "Үлдэгдэл рүү хөрвүүлэх",
          rollingPercentage: {
            slot: "Эргэлтийн % (Слот)",
            casino: "Эргэлтийн % (Казино)",
            sports: "Эргэлтийн % (Спорт)",
          },
          losingPercentage: {
            slot: "Алдагдлын % (Слот)",
            casino: "Алдагдлын % (Казино)",
            sports: "Алдагдлын % (Спорт)",
          },
        },
        bettingAndRolling: {
          title: "Бооцоо & Эргэлт",
          bettingWinning: {
            title: "Бооцоо / Хожил",
            slot: "Бооцоо / Хожил (Слот)",
            casino: "Бооцоо / Хожил (Казино)",
            sports: "Бооцоо / Хожил (Спорт)",
          },
          rolling: {
            slot: "Эргэлт (Слот)",
            casino: "Эргэлт (Казино)",
            sports: "Эргэлт (Спорт)",
          },
        },
        moneyMovement: {
          title: "Мөнгөний хөдөлгөөн",
          totalDeposit: "Нийт орлого",
          totalWithdraw: "Нийт зарлага",
          totalChipGive: "Нийт өгсөн чип",
          totalChipCollect: "Нийт цуглуулсан чип",
        },
      },
    },
    chipTransfer: {
      title: "Түншийн чип шилжүүлэг",
      desc: "Түншийн чип шилжүүлгийг удирдах",
      columns: {
        fromUser: "Илгээгч",
        fromRole: "Илгээгчийн үүрэг",
        toUser: "Хүлээн авагч",
        toRole: "Хүлээн авагчийн үүрэг",
        amount: "Дүн",
        memo: "Тэмдэглэл",
        createdAt: "Шилжүүлгийн цаг",
      },
    },
    partnerUserChipTransfer: {
      title: "Түнш ↔ Хэрэглэгч чип шилжүүлэг",
      desc: "Түнш, хэрэглэгчийн хоорондын чип шилжүүлгийг удирдах",
      search: {
        placeholder: "Түнш эсвэл хэрэглэгчийн нэрийг оруулна уу",
      },
      columns: {
        partnerUsername: "Түншийн нэр",
        partnerRole: "Түншийн үүрэг",
        username: "Хэрэглэгчийн нэр",
        giveAmount: "Өгсөн дүн",
        collectAmount: "Цуглуулсан дүн",
        createdAt: "Цаг",
      },
    },
  },
  banking: {
    rechargeHistory: {
      title: "Мөнгөний нэмэлт түүх",
      desc: "Мөнгөний нэмэлт түүхийн хуудас",
      columns: {
        id: "#",
        type: "Төрөл",
        amount: "Мөнгөний дүн",
        countAndTotal: "Мөнгөний тоо / Нийт",
        balanceChange: "Өмнө / Хойно",
        username: "Хэрэглэгчийн нэр",
        affiliation: "Хамтрал",
        bankName: "Банкны нэр",
        accountHolder: "Данс эзэмшигч",
        dates: "Өгөгдөл / Үйлдэл",
        status: "Төлөв",
        details: "Дэлгэрэнгүй",
        memo: "Тэмдэглэл",
        deposit: "Мөнгөний нэмэлт",
        withdraw: "Мөнгөний гаргалт",
      },
    },
    exchangeHistory: {
      title: "Мөнгөний солилох түүх",
      desc: "Мөнгөний солилох түүхийн хуудас",
      columns: {
        id: "#",
        type: "Төрөл",
        amount: "Мөнгөний дүн",
        countAndTotal: "Мөнгөний тоо / Нийт",
        balanceChange: "Өмнө / Хойно",
        username: "Хэрэглэгчийн нэр",
        affiliation: "Хамтрал",
        bankName: "Банкны нэр",
        accountHolder: "Данс эзэмшигч",
        dates: "Өгөгдөл / Үйлдэл",
        status: "Төлөв",
        details: "Дэлгэрэнгүй",
        memo: "Тэмдэглэл",
        deposit: "Мөнгөний нэмэлт",
        withdraw: "Мөнгөний гаргалт",
      },
    },
  },
  notices: {
    list: {
      title: "Мэдэгдлийн удирдлага",
      desc: "Мэдэгдлийн удирдлагын хуудас",
      createButton: "Мэдэгдэл үүсгэх",
      columns: {
        title: "Гарчиг",
        status: "Төлөв",
        viewCount: "Үзсэн",
        createdAt: "Үүсгэсэн огноо",
        updatedAt: "Шинэчилсэн огноо",
        actions: "Үйлдлүүд",
        pinButton: "Бэхлэх",
        unpinButton: "Бэхлэлт авах",
        viewButton: "Харах",
        editButton: "Засах",
        deleteButton: "Устгах",
      },
    },
    detail: {
      title: "Мэдэгдлийн дэлгэрэнгүй",
      desc: "Мэдэгдлийн дэлгэрэнгүй хуудас",
      notFound: "Мэдэгдэл олдсонгүй",
    },
    edit: {
      title: "Мэдэгдэл засах",
      desc: "Мэдэгдэл засах хуудас",
      titleLabel: "Гарчиг",
      contentLabel: "Агуулга",
      statusLabel: "Төлөв",
      pinnedLabel: "Дээр бэхлэх",
    },
    delete: {
      title: "Мэдэгдэл устгах",
      desc: "Энэ мэдэгдлийг устгахдаа итгэлтэй байна уу?",
    },
    status: {
      all: "Бүгд",
      draft: "Ноорог",
      published: "Нийтлэгдсэн",
      deleted: "Устгагдсан",
    },
  },
  inquiry: {
    types: {
      deposit: "Цэнэглэлтийн асуулга",
      withdrawal: "Солилцооны асуулга",
      account: "Бүртгэлийн асуулга",
      other: "Бусад асуулга",
    },
  },
  inquiries: {
    list: {
      title: "1:1 Асуулга",
      desc: "Асуулгын жагсаалтын хуудас",
      columns: {
        title: "Гарчиг",
        status: "Төлөв",
        creator: "Үүсгэгч",
        createdAt: "Үүсгэсэн огноо",
        answerer: "Хариулагч",
        answeredAt: "Хариулсан огноо",
      },
      search: {
        placeholder: "Гарчиг эсвэл агуулгаар хайх",
      },
      noData: "Асуулгын түүх байхгүй",
    },
    detail: {
      title: "Асуулгын дэлгэрэнгүй",
      desc: "Асуулгын дэлгэрэнгүй хуудас",
      notFound: "Асуулга олдсонгүй",
    },
    status: {
      all: "Бүгд",
      pending: "Хүлээгдэж байна",
      inProgress: "Боловсруулж байна",
      completed: "Дууссан",
      deleted: "Устгагдсан",
    },
    answer: {
      title: "Хариулт",
      status: "Төлөв",
      content: "Агуулга",
      placeholder: "Хариултаа оруулна уу",
      submit: "Хариулт илгээх",
      success: "Хариулт амжилттай илгээгдлээ",
      error: "Хариулт илгээхэд алдаа гарлаа",
      required: "Хариулт оруулна уу",
    },
  },
  bettingStatus: {
    common: {
      rollingDesc: "※ Эргэлт = Бооцоо x Эргэлтийн%, ※ Бодит = Эргэлт - Доод түвшний эргэлт",
      losingDesc: "※ Алдагдал = (Бооцоо - Хожил - Нийт эргэлт) x Эргэлтийн%, ※ Бодит = Алдагдал - Доод түвшний алдагдал",
      selectedPartner: "Сонгогдсон түншийн бооцоо & эргэлтийн өгөгдөл",
      downlinePartners: "Доод түвшний түншүүдийн бооцоо & эргэлтийн өгөгдөл",
    },
    slot: {
      title: "Бооцооны төлөв(Слот)",
      desc: "Слот бооцооны төлөвийн хуудас",
    },
    casino: {
      title: "Бооцооны төлөв(Казино)",
      desc: "Казино бооцооны төлөвийн хуудас",
    },
    sports: {
      title: "Бооцооны төлөв(Спорт)",
      desc: "Спорт бооцооны төлөвийн хуудас",
    },
    slotHistory: {
      title: "Бооцооны түүх(Слот)",
      desc: "Слот бооцооны түүхийн хуудас",
    },
    casinoHistory: {
      title: "Бооцооны түүх(Казино)",
      desc: "Казино бооцооны түүхийн хуудас",
    },
    sportsHistory: {
      title: "Бооцооны түүх(Спорт)",
      desc: "Спорт бооцооны түүхийн хуудас",
    },
    losingSettlement: {
      slot: {
        title: "Алдагдлын тооцоо(Слот)",
        desc: "Слотын алдагдлын тооцооны хуудас",
      },
      casino: {
        title: "Алдагдлын тооцоо(Казино)",
        desc: "Казиногийн алдагдлын тооцооны хуудас",
      },
      sports: {
        title: "Алдагдлын тооцоо(Спорт)",
        desc: "Спортын алдагдлын тооцооны хуудас",
      },
      columns: {
        role: "Үүрэг",
        partnerName: "Түншийн нэр",
        totalPartnerDeposit: "Түншийн нийт орлого",
        totalPartnerWithdraw: "Түншийн нийт зарлага",
        totalBetting: "Нийт бооцоо",
        totalWinning: "Нийт хожил",
        bettingResult: "Нийт бооцоо - Нийт хожил",
        rollingPercentage: "Эргэлтийн %",
        totalRolling: "Нийт эргэлт",
        actualRolling: "Бодит эргэлт",
        losingPercentage: "Алдагдлын %",
        losingAmount: "Алдагдлын дүн",
        settlementAmount: "Тооцооны дүн",
        downlineSettlementAmount: "Доод түвшний тооцооны дүн",
        actualPaymentAmount: "Бодит төлбөрийн дүн",
      },
    },
    lossAdjustment: {
      title: "Алдагдлын тохируулга",
      desc: "Алдагдлын тохируулгын хуудас",
      columns: {
        headquarter: "Төв",
        branch: "Салбар",
        storeUsername: "Дэлгүүрийн хэрэглэгчийн нэр",
        yesterdayBetting: "Өчигдрийн бооцоо",
        yesterdayWin: "Өчигдрийн хожил",
        yesterdayRolling: "Өчигдрийн эргэлт",
        subtract: "Хасах",
        loss: "АЛДАГДАЛ",
        add: "Нэмэх",
      },
      buttons: {
        setAll0: "Бүгдийг 0 болгох",
        setAll5: "Бүгдийг 5 болгох",
        setAll10: "Бүгдийг 10 болгох",
        setAll15: "Бүгдийг 15 болгох",
        setAll20: "Бүгдийг 20 болгох",
      },
    },
    lossRecovery: {
      title: "Алдагдлын нөхөлт",
      desc: "Алдагдлын нөхөлтийн хуудас",
      columns: {
        storeName: "Дэлгүүрийн нэр",
        username: "Хэрэглэгчийн нэр",
        gameName: "Тоглоомын нэр",
        date: "Огноо",
        bettingAmount: "Бооцооны дүн",
        winningAmount: "Хожлын дүн",
        rollingAmount: "Эргэлтийн дүн",
        storeRecoveryStatus: "Дэлгүүрийн нөхөлтийн төлөв",
        userRecoveryStatus: "Хэрэглэгчийн нөхөлтийн төлөв",
        status: "Төлөв",
      },
    },
    bettingStatusColumns: {
      role: "Үүрэг",
      partnerName: "Түншийн нэр",
      totalPartnerDeposit: "Түншийн нийт орлого",
      totalPartnerWithdraw: "Түншийн нийт зарлага",
      totalBetting: "Нийт бооцоо",
      totalWinning: "Нийт хожил",
      bettingResult: "Бооцоо - Хожил",
      rollingPercentage: "Эргэлтийн %",
      totalRolling: "Нийт эргэлт",
      actualRolling: "Бодит эргэлт",
      bettingProfit: "Бооцооны ашиг",
      currentChip: "Одоогийн чип",
      currentRolling: "Одоогийн эргэлт",
    },
  },
  swagger: {
    title: "API Баримт бичиг",
    description: "Гахайн Сан Админ API Баримт бичиг.",
  },
  settings: {
    title: "Тохиргоо",
    description: "Системийн тохиргоог удирдах",
    tabs: {
      general: "Ерөнхий",
      currency: "Валют",
      exchange: "Ханш",
      game: "Тоглоом",
      etc: "Бусад",
    },
    groups: {
      general: {
        title: "Ерөнхий тохиргоо",
        description: "Ерөнхий системийн тохиргоог тохируулах.",
      },
      currency: {
        title: "Валютын тохиргоо",
        description: "Валют харуулах болон стандарт тохиргоог удирдах.",
      },
      exchange: {
        title: "Ханшийн тохиргоо",
        description: "USDT ханштай холбоотой тохиргоог удирдах.",
      },
      game: {
        title: "Тоглоомын тохиргоо",
        description: "Нийлүүлэгчийг оролцуулаад тоглоомтой холбоотой тохиргоог тохируулах.",
      },
      etc: {
        title: "Бусад тохиргоо",
        description: "Бусад төрөл бүрийн тохиргоог удирдах.",
      },
    },
    fields: {
      site_name: {
        label: "Сайтын нэр",
        description: "Вэбсайтын нэр.",
      },
      maintenance: {
        label: "Засварын горим",
        description: "Сайтын засварын горимыг идэвхжүүлэх эсвэл идэвхгүй болгох. (on/off)",
      },
      std_currency: {
        label: "Стандарт валют",
        description: "Тооцоололд ашиглагдах стандарт валют.",
      },
      dsp_currency: {
        label: "Харуулах валют",
        description: "Хэрэглэгчдэд харуулах валют.",
      },
      usdt_exchange_rate: {
        label: "USDT ханшийн тохиргоо",
        description: "USDT ханшийн JSON өгөгдлийн засварлагч.",
      },
      std_game_vendor_id: {
        label: "Стандарт тоглоомын нийлүүлэгч",
        description: "Үндсэн тоглоомын нийлүүлэгчийн ID.",
      },
      // Бусад талбаруудын орчуулгыг энд нэмж болно.
    },
    messages: {
      settingKeyNotFound: "Тохиргооны түлхүүр '$key'-д индекс олдсонгүй",
      loadingSettings: "Тохиргоог ачааллаж байна...",
      errorLoadingSettings: "Тохиргоог ачаалахад алдаа гарлаа",
    },
    save_success: "Тохиргоо амжилттай хадгалагдлаа!",
  },
  usdtExchangeRateEditor: {
    rawJsonEditorTitle: "JSON засварлагч",
    exchangeRateAndWalletSettingsTitle: "Ханш & Түрийвчний тохиргоо",
    usdtExchangeRateLabel: "USDT ханш (ex_rate)",
    myWalletUrlLabel: "Миний түрийвчний URL (my_wallet)",
    quickAmountsSettingsTitle: "Шуурхай дүнгийн тохиргоо:",
    quickAmounts: {
      hide: "(Нуух)",
      show: "(Харуулах)",
      amountPlaceholder: "Дүн",
      labelPlaceholder: "Шошго (жишээ нь: $10)",
      addAmountButton: "Шуурхай дүн нэмэх",
    },
    addLanguagePrompt: "Нэмэх хэлний кодыг оруулна уу (жишээ нь: en):",
    languageExistsError: "Энэ хэлний тохиргоо аль хэдийн байна.",
    addNewLanguageQuickAmountButton: "Шинэ хэлний шуурхай дүн нэмэх",
    wallets: {
      title: "Гаргах түрийвч (wallets)",
      walletNumberLabel: "Түрийвч",
      namePlaceholder: "Түрийвчний нэр (жишээ нь: Polygon Tether)",
      addressPlaceholder: "Түрийвчний хаяг",
      qrPlaceholder: "QR кодын зурагны зам (жишээ нь: /uploads/polygon-img.jpeg)",
      deleteWalletButton: "Энэ түрийвчийг устгах",
      addWalletButton: "Гаргах түрийвч нэмэх",
    },
    errors: {
      invalidJsonParse: "JSON формат буруу байна",
      failedStringifyJson: "JSON болгоход алдаа гарлаа (onChange)",
      invalidJsonFormatOrUseUI:
        "JSON формат буруу байна. Шууд засварлах эсвэл доорх UI-г ашиглана уу.",
    },
    rawJsonEditor: {
      editJsonDirectlyLabel: "JSON шууд засварлах",
      warningMessage:
        "Анхаар: JSON формат буруу бол тохиргоо зөв хадгалагдахгүй байж болзошгүй.",
    },
    loadingEditor: "Засварлагчийг ачааллаж байна...",
  },
};

export default data; 